import React from 'react';

import { Checkbox } from 'cpool-components/input/Checkbox';

import type { SchemaDemandedDocumentsKeys } from '~/features/leadDetails/schemas/demandedDocuments.schema';

type Props = {
    category: SchemaDemandedDocumentsKeys;
    document: string;
    requested: boolean;
    update: (path: SchemaDemandedDocumentsKeys, name: string, requested: boolean) => void;
    disabled?: boolean;
};
const DocumentEntry: React.FC<Props> = ({ category, disabled, document, requested, update }) => {
    return (
        <Checkbox
            id={`${category}-${document}`}
            name={document}
            label={document}
            checked={requested}
            onChange={(e) => update(category, document, e.target.checked)}
            disabled={disabled}
        />
    );
};

export default DocumentEntry;
